export const APPOINTMENT_DETAILS_STRINGS = {
    TooltipContent:
        "This is a number that is usually found on your health insurance card. It helps the doctor's office verify your coverage.",
    MemberIdFromCardImageTooltipContent:
        'Your member ID is stored securely and was collected from your insurance card.' +
        " It helps the doctor's office verify your coverage.",

    MemberIdFromCardImageTooltipContentWithOptionalText:
        'Your member ID is stored securely and was collected from your insurance card.' +
        " It helps the doctor's office verify your coverage. (This is optional)",

    InsuranceIdRequired: 'Please type your member ID number.',
    LinkInsuranceCardRequired:
        'This doctor requires insurance card information to book.',
};
